import { Tooltip, TooltipProps, withStyles } from "@material-ui/core";
import { default as React } from "react";

// TODO (lsanwick) Migrate to design system Tooltip, it doesn't support interactive yet.
const InteractiveTooltip: React.FC<TooltipProps> = ({ ...props }) => (
  <Tooltip
    {...props}
    interactive
    tabIndex={0}
    placement="right"
    TransitionProps={{ timeout: 200 }} // how quickly the tooltip appears in ms
  />
);

export const InteractiveTooltipStyled = withStyles(() => ({
  tooltip: {
    backgroundColor: "transparent",
  },
}))(InteractiveTooltip);
